<template>
  <div class="managers-pay-page">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="— 暂无更多数据 —"
      :offset="10"
      :immediate-check="false"
      @load="onLoad"
    >
      <div v-if="finished && record.length !== 0">
        <div class="bottom-line tip">充值记录</div>
      </div>
      <div v-for="(item, key) in RecordList" :key="key" class="record">
        <div class="bottom-line">
          <div class="flex" v-if="item.id!=0">
            <span>品牌负责人ID</span>
            <span>{{item.id}}</span>
          </div>
          <div class="flex" v-else>
            <span>活动方代充</span>
          </div>
          <div class="flex" v-if="item.id!=0">
            <span>品牌负责人姓名</span>
            <span>{{item.kpiUserName}}</span>
          </div>
          <div class="flex" v-if="item.id!=0">
            <span>手机号</span>
            <span>{{item.mobile}}</span>
          </div>
          <div class="flex">
            <span>充值金额（元）</span>
            <span>{{item.amount}}</span>
          </div>
          <div class="flex">
            <span>充值类型</span>
            <span v-if="item.type=='brand_bonus_bean'">品牌奖励豆奖金池</span>
            <span v-if="item.type=='staff_bonus_bean'">导购员奖励豆奖金池</span>
            <span v-if="item.type=='brand_penalty'">品牌惩罚承诺金</span>
            <span v-if="item.type=='user_share_bonus'">客户分享奖励</span>
            <span v-if="item.type=='staff_single_bonus'">导购员单项奖励金</span>
            <span v-if="item.type=='live_red_package'">直播间红包</span>
            <span v-if="item.type=='other_promotion_expenses'">其他推广费用</span>
            <span v-if="item.type=='staff_bonus'">导购员奖金池</span>
          </div>
          <div class="flex">
            <span>充值时间</span>
            <span>{{item.createTime}}</span>
          </div>
        </div>
      </div>
    </van-list>

    <!-- <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { activity_id: activity.id }}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity: {},
      amount: null,
      remark: "",
      page: 1,
      loading: false,
      finished: false,
      record: [],
      RecordList: [],
      count: 0, //总条数
      nowpage: 1, //当前页
    };
  },
  created() {
    this.getChargeRecord();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 加载更多充值记录
    onLoad() {
      console.log(233);
      // 获取当前的总条数，当前页数。
      // 如果条数除以10向上取整，大于当前页数，则执行一次加载
      if (Math.ceil(this.count / 10) > this.nowpage) {
        this.nowpage = this.nowpage + 1;
        this.getChargeRecord();
      } else {
        if (this.nowpage != 1) {
          this.finished = true;
        }
      }
      this.loading = false;
    },
    async getChargeRecord() {
      var actId = localStorage.getItem("act_id");
      let res = await this.$http.post(
        `/v1/kpiuser/my_charge_record?page=${this.nowpage}&size=10`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        var list = res.data.list;
        // 下拉判断
        if (this.nowpage === 1) {
          this.RecordList = list || [];
        } else {
          this.RecordList = this.RecordList.concat(list);
        }
        this.count = res.data.total;
      }
    },
  },
};
</script>

<style lang="less">
.managers-pay-page {
  .tip {
    padding: 10px 15px;
    background-color: #ffffff;
    color: #1a1a1a;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .record {
    /*充值记录*/
    //background-color: #ffffff;
    //padding: 10px 15px;
    .bottom-line {
      background-color: #ffffff;
      padding: 10px 15px;
      .flex {
        // border: 1px solid #999999;
        display: flex;
        span {
          flex: 1;
          padding: 5px 10px;
        }
      }
      margin-bottom: 10px;
      box-shadow: #e2e4e2 0px 6px 8px -2px;
    }
    .bottom-line:after {
      left: 15px;
    }
    .time {
      color: #999999;
      margin-top: 5px;
      font-size: 12px;
    }
  }
}
</style>
